interface IErrorCodeTable {
  [key: string]: string;
}

export interface IAPIError {
  extensions: { code: string };
}

const compareTable: IErrorCodeTable = {
  AppHookEventsNotAllowed: 'errors.hookEvent.notAllowed',
  INTERNAL_SERVER_ERROR: 'errors.server.internal',
  AppNameAlreadyUsed: 'form.step.app.details.name.duplicate.error',
};

export default (apiError: IAPIError, fallback?: string): string => {
  const serverCode = apiError?.extensions?.code;
  return compareTable[serverCode] ?? fallback ?? 'errors.somethingWentWrong';
};
